import styled from 'styled-components';
import { token } from '@zillow/constellation';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.main`
  width: 100%;
  max-width: 1220px;
`;

type SectionPropType = { usePadding: boolean | null; useMarginTop: boolean };
export const Section = styled.section`
  background: white;
  margin-bottom: 16px;

  margin-top: ${({ useMarginTop }: SectionPropType) => (useMarginTop ? '16px;' : '')};
  padding: ${({ usePadding }: SectionPropType) => (usePadding ? '24px 24px 40px 24px;' : '')};
`;

export const SectionBorder = styled.hr`
  border: none;
  height: 1px;
  background: ${token('colors.gray300')};
  margin: 0;
  margin-bottom: 16px;
`;
